import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import { apiEndpoints } from '../../app.constants';
import { BackendHttpService } from '../../core/backend-http.service';
import { ErrorTemplate } from '../../../models/ErrorTemplate';
import { CreditUsage, CreditAdding, InvoiceUploading } from '../../../models/company/company';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { DateUtils } from '../../utils/date.utils';

@Injectable()
export class AdminService extends BackendHttpService<any> {


  constructor(public router: Router, public translate: TranslateService) {
    super(router, translate);
  }

  public searchCompanies(data): Observable<any> {
    return this.post(apiEndpoints.searchCompanies, data);
  }

  public getNumberOfCompanies(data): Observable<any> {
    return this.post(apiEndpoints.getNumberOfCompanies, data);
  }

  public getAllCompanyType(): Observable<any> {
    return this.get(apiEndpoints.getAllCompanyType);
  }

  public updatePaymentMethod(data): Observable<any> {
    return this.post(apiEndpoints.updatePaymentMethod, data);
  }

  public validateUserPaymentDetails(userPayment): ErrorTemplate[] {
    const errors: ErrorTemplate[] = [];
    if (!userPayment.paymentId) {
      errors.push({name: 'payment_method',
        message: this.translate.instant('user_company.please_select_payment_method')});
    }

    if (userPayment.paymentId === 'credit' && !userPayment.accountLevel) {
      errors.push({name: 'account_level',
        message: this.translate.instant('user_company.please_select_account_level')});
    }

    return errors;
  }

  public getCreditAccountList(): Observable<any> {
    return this.get(apiEndpoints.getCreditAccountList);
  }

  public saveCreditUsage(data): Observable<any> {
    return this.post(apiEndpoints.saveCreditUsage, data);
  }

  public updateNumberOfCredits(data): Observable<any> {
    return this.put(apiEndpoints.updateNumberOfCredits, data);
  }

  public getCreditUsageList(orderId): Observable<any> {
    const param = {orderId};
    return this.get(apiEndpoints.getCreditUsageList, param);
  }

  public getCreditInvoiceList(orderId): Observable<any> {
    const param = {orderId};
    return this.get(apiEndpoints.getCreditInvoiceList, param);
  }

  public createInvoice(data): Observable<any> {
    return this.post(apiEndpoints.createInvoice, data);
  }

  public updateCreditInvoice(data): Observable<any> {
    return this.put(apiEndpoints.updateCreditInvoice, data);
  }

  public validateUpdateUsageData(creditUsage: CreditUsage): ErrorTemplate[] {
    const errors: ErrorTemplate[] = [];
    this.validateNumber(creditUsage.numberOfSpentCredits, 'credit_amount', errors);
    if (!creditUsage.date || !DateUtils.isValidNgbDateStruct(creditUsage.date)) {
      errors.push({name: 'date',
        message: this.translate.instant('user_and_billing.please_input_date')});
    }
    return errors;
  }

  public validateCreditAddingData(creditAdding: CreditAdding): ErrorTemplate[] {
    const errors: ErrorTemplate[] = [];
    this.validateNumber(creditAdding.numberOfCredits, 'credit_amount', errors);
    return errors;
  }

  public validateUploadInvoiceData(invoiceUpload: InvoiceUploading): ErrorTemplate[] {
    const errors: ErrorTemplate[] = [];
    this.validateNumber(invoiceUpload.amount, 'price_amount', errors);
    if (!invoiceUpload.invoiceDate || !DateUtils.isValidNgbDateStruct(invoiceUpload.invoiceDate)) {
      errors.push({name: 'invoice_date',
        message: this.translate.instant('user_and_billing.please_input_date')});
    }
    if (!invoiceUpload.dueDate || !DateUtils.isValidNgbDateStruct(invoiceUpload.dueDate)) {
      errors.push({name: 'due_date',
        message: this.translate.instant('user_and_billing.please_input_date')});
    }
    if (!invoiceUpload.invoiceNumber) {
      errors.push({name: 'invoice_number',
        message: this.translate.instant('user_and_billing.please_input_invoice_number')});
    }
    return errors;
  }

  private validateNumber(numberText, fieldName: string, errors: ErrorTemplate[]) {
    if (!numberText) {
      errors.push({name: fieldName,
        message: this.translate.instant('user_and_billing.please_input_number')});
    } else {
      if (!isNumber(Number(numberText))) {
        errors.push({name: fieldName,
        message: this.translate.instant('user_and_billing.please_input_in_number_format')});
      } else {
        if (Number(numberText) <= 0) {
          errors.push({name: fieldName,
            message: this.translate.instant('user_and_billing.please_input_in_positive_integer')});
        }
      }
    }
    return errors;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/admin/admin.service.ts